<!--
 * @Author: your name
 * @Date: 2020-10-20 08:10:24
 * @LastEditTime: 2020-10-20 11:49:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \wzl\src\components\about\responsibility.vue
-->
<template>
  <div
    class="responsibility"
    :style="{
      backgroundImage: 'url(' + our_mission.img + ')',
    }"
  >
    <div>
      <p class="title">Social <br />responsibility</p>
      <span class="pub-sub-title">社会责任</span>
      <div>
        {{ our_mission.intro }}
      </div>
    </div>
    <img class="mobile" :src="our_mission.img" alt="" />
  </div>
</template>

<script>
import { our_mission } from '../../utils/api'
export default {
  data() {
    return {
      our_mission: {},
    }
  },
  created() {
    our_mission((r) => {
      this.our_mission = r.data
    })
  },
}
</script>

<style scoped lang="less">
.responsibility {
  background-size: cover;
  background-repeat: no-repeat;
  padding: 120px 0;
  & > div {
    width: 900px;
    background: linear-gradient(
      90deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 77%,
      rgba(255, 255, 255, 0) 100%
    );
    padding: 80px 160px;
    box-sizing: border-box;
    .title {
      font-size: 18px;
      font-family: Arial;
      font-weight: 400;
      color: #909090;
      margin-bottom: 24px;
    }
    .pub-sub-title::after {
      width: 80px;
      transform: translateX(0);
      left: 0;
    }
    div {
      width: 364px;
      height: 132px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 28px;
      color: #4d4d4d;
      overflow-y: auto;
      position: relative;
      margin-top: 34px;
      word-break: break-all;
      overflow-x: hidden;
      padding-right: 20px;
    }
    div::-webkit-scrollbar {
      width: 2px;
      background-color: transparent;
    }

    div::-webkit-scrollbar-track {
      border-radius: 10px;
    }

    div::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background: #006C8F;
    }
  }
}
@media (max-width: 767px) {
  .responsibility {
    padding: 0;
    background-image: unset !important;
    & > img {
      width: 100%;
      height: 2.6rem;
      object-fit: cover;
      margin-top: 0.24rem;
    }
    & > div {
      width: 100%;
      padding: 0 0.34rem;
      .title {
        font-size: 0.28rem;
        margin-bottom: -0.4rem;
      }
      .pub-sub-title {
        font-size: 0.4rem;

        font-family: Microsoft YaHei;
        font-weight: 400;
        color: black;
      }
      .pub-sub-title::after {
        width: 1.6rem;
      }
      div {
        width: 100%;
        height: 2.64rem;
        padding-right: 0.2rem;
        margin-top: .4rem;
      }
      div::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #006C8F;
      }
    }
  }
}
</style>